var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7512 7.33251L18.5941 0.386472C18.8732 0.139044 19.2506 0 19.644 0C20.0374 0 20.4149 0.139044 20.6939 0.386472C20.8316 0.507815 20.9408 0.652199 21.0154 0.811493C21.09 0.970787 21.1284 1.14163 21.1284 1.31427C21.1284 1.4869 21.09 1.65807 21.0154 1.81736C20.9408 1.97666 20.8316 2.12104 20.6939 2.24239L11.8026 10.1185C11.5236 10.3659 11.1461 10.505 10.7527 10.505C10.3592 10.505 9.98178 10.3659 9.70273 10.1185L0.81143 2.24239C0.673796 2.12104 0.5645 1.97666 0.489921 1.81736C0.415342 1.65807 0.376953 1.4869 0.376953 1.31427C0.376953 1.14163 0.415342 0.970787 0.489921 0.811493C0.5645 0.652199 0.673796 0.507815 0.81143 0.386472C1.09048 0.139044 1.46794 0 1.86137 0C2.2548 0 2.63217 0.139044 2.91122 0.386472L10.7512 7.33251Z",
  fill: "#3A36DB"
});

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 11,
    viewBox: "0 0 22 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.513c1f880438e2abf5f2248c3e0c854c.svg";
export { ForwardRef as ReactComponent };